 export const LoggedDetail={
    userId:'',    
    firstName: '',
    lastName: '', 
    profileImage: '',
    isUserLoggedIn: false,   
    loggedDetailId: 0,
    notificationCount:0   
}
